import { createContext, useState } from 'react'

import { NfseScheduled } from 'models/NFe'
import { PaymentTypeDetails } from 'models/PaymentTypeDetails'

export type InstallmentData = {
  uuid: string
  amount: string
  payment_type: string
  total_cycles: number
  status: string
  description: string
  installment_amount: number
  created_at: string
  updated_at: string
  paymentTypeDetails?: PaymentTypeDetails
  nfse_scheduled?: NfseScheduled
  nfse_policy?: string
  nfse_issue_date?: string
  billing_items?: Array<{
    uuid: string
    quantity: number
    product?: {
      uuid: string
      name: string
      total_cycles?: number
    }
    description?: string
    amount_billed: string
    amount_unit: string
    bonus_policy?: 'no_bonus' | 'fixed' | 'percentage'
    bonus_amount?: number | string
  }>
  merchant: {
    uuid: string
    name: string
    document: string
    email: string
  }
  customer: {
    uuid: string
    name: string
    email: string
    document: string
    phone: string
    status: string
  }
  billings: Array<{
    uuid: string
    description: string
    amount_billed: string
    amount_paid: string
    due_date: string
    date_paid: string | null
    status: string
    installment_cycle: number
    issue_date: string
    expiration_date: string
    created_at: string
    updated_at: string
    recurrence_cycle?: number
    recurrence_uuid?: string
    recurrence?: {
      uuid: string
      total_cycles: number
    }
    customer: {
      uuid: string
      name: string
      email: string
      document: string
    }
    payments: Array<{
      uuid: string
      payment_type: string
      status: string
      amount_billed: string
      amount_paid: string
      due_date: string
      date_paid: string | null
      fee: string | null
      bank_fee: string
      base_fee: string | null
    }>
  }>
}

export type ModalInstallmentDetailContextType = {
  installment: InstallmentData
  updateInstallment: (installment: InstallmentData) => void
  loading: boolean
  setLoading: (loading: boolean) => void
}

export const ModalInstallmentDetailContext = createContext(
  {} as ModalInstallmentDetailContextType
)

type ModalInstallmentDetailProviderProps = {
  children: React.ReactNode
}

export function ModalInstallmentDetailProvider({
  children
}: ModalInstallmentDetailProviderProps) {
  const [installment, setInstallment] = useState<InstallmentData>(
    {} as InstallmentData
  )
  const [loading, setLoading] = useState(true)

  const updateInstallment = (installmentData: InstallmentData) => {
    setInstallment(installmentData)
  }

  return (
    <ModalInstallmentDetailContext.Provider
      value={{
        installment,
        updateInstallment,
        loading,
        setLoading
      }}
    >
      {children}
    </ModalInstallmentDetailContext.Provider>
  )
}
